<div id="global-wrapper-content">
  <router-outlet></router-outlet>
<!--  <app-loading ></app-loading>-->
</div>
